import React from "react";
import { Button, Empty, Tooltip } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import ChecklistSheet from "./ChecklistSheet";
import useRampChecklist from "./useRampChecklist";

/**
 * 桌面端航班详情抽屉里的"过站检查单"标签页（只读）。
 * 用纸质表版式（ChecklistSheet）还原纸质《Ramp Transit Checklist》的样子；
 * 数据走只读的 useRampChecklist（只 get、不隐式建单）。手机端录入仍用 ChecklistBody。
 * 导出 PDF 与手机端同一条链路（downloadChecklistPdf），版式一致。
 */
export default function RampChecklistTab({ flightId }) {
    const state = useRampChecklist(flightId, { readOnly: true });
    const { checklist, loading, exporting, handleExport } = state;

    if (!flightId) {
        return <Empty description="无航段信息" style={{ padding: 32 }} />;
    }

    const exportable = !!checklist?.initialized;

    return (
        <div>
            {!loading && (
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                    <Tooltip title={exportable ? "" : "尚未开始过站检查，暂无内容可导出"}>
                        <Button icon={<FilePdfOutlined />} loading={exporting} disabled={!exportable} onClick={handleExport}>
                            下载 PDF
                        </Button>
                    </Tooltip>
                </div>
            )}
            <div style={{ maxHeight: "calc(100vh - 240px)", overflowY: "auto", paddingRight: 4 }}>
                <ChecklistSheet state={state} />
            </div>
        </div>
    );
}
